import { render, staticRenderFns } from "./UploadedDocumentsSummary.vue?vue&type=template&id=f82b00a0&scoped=true&"
import script from "./UploadedDocumentsSummary.vue?vue&type=script&lang=js&"
export * from "./UploadedDocumentsSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f82b00a0",
  null
  
)

export default component.exports